import { render, staticRenderFns } from "./BotKeyboardChat.vue?vue&type=template&id=421bdf9e&scoped=true&lang=pug&"
import script from "./BotKeyboardChat.vue?vue&type=script&lang=js&"
export * from "./BotKeyboardChat.vue?vue&type=script&lang=js&"
import style0 from "./BotKeyboardChat.vue?vue&type=style&index=0&id=421bdf9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421bdf9e",
  null
  
)

export default component.exports